import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  Interval,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  isWithinInterval,
  min,
  max,
  eachDayOfInterval,
  getDay,
  getOverlappingDaysInIntervals,
  addSeconds,
  areIntervalsOverlapping,
} from 'date-fns';
import { Subject } from 'rxjs';
import { BackEndCalendarEvent, TeamMember, ChecklistTemplate, sanitizeIdentifier } from 'huddyapi';

import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { EventColor } from 'calendar-utils';

import { UserTeam } from '../../services/community-config.service';



// const colors: Record<string, EventColor> = {
//   red: {
//     primary: '#ad2121',
//     secondary: '#FAE3E3',
//   },
//   blue: {
//     primary: '#1e90ff',
//     secondary: '#D1E8FF',
//   },
//   yellow: {
//     primary: '#e3bc08',
//     secondary: '#FDF1BA',
//   },
// };

@Component({
  selector: 'calendar-view',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./calendar-view.scss'],
  templateUrl: './calendar-view.html',
})
export class CalendarViewComponent implements OnChanges {
  @Input()
  baseCalendarEvents: BackEndCalendarEvent[] = [];
  @Input()
  currentTeam : UserTeam;
  @Input()
  currentTeamMembers : TeamMember[];

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Day;
  @Output() editCalendarEvent  : EventEmitter<CalendarBackEndPair> = new EventEmitter();
  CalendarView = CalendarView;

  viewDate: Date = new Date();
  startTime: number = 0;
  endTime: number = 24;


  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [];
  //   {
  //     label: '<i class="fas fa-fw fa-pencil-alt"></i>',
  //     a11yLabel: 'Edit',
  //     onClick: ({ event }: { event: CalendarEvent }): void => {
  //       this.handleEvent('Edited', event);
  //     },
  //   },
  //   {
  //     label: '<i class="fas fa-fw fa-trash-alt"></i>',
  //     a11yLabel: 'Delete',
  //     onClick: ({ event }: { event: CalendarEvent }): void => {
  //       this.events = this.events.filter((iEvent) => iEvent !== event);
  //       this.handleEvent('Deleted', event);
  //     },
  //   },
  // ];

  refresh = new Subject<void>();

  events: CalendarEvent[] = [];

  activeDayIsOpen: boolean = true;

  constructor(


  ) { }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['baseCalendarEvents']) {
      this.handleEventUpdate();
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    //this.modalData = { event, action };
    let backendEvents : BackEndCalendarEvent[] = this.baseCalendarEvents.filter(e => this.makeItemId(e) === event.id);
    const backendEvent : BackEndCalendarEvent = (backendEvents.length > 0) ? backendEvents[0] : undefined;
    this.editCalendarEvent.emit({
      action: action,
      calendarEvent: event,
      backendEvent : backendEvent
    });
    // this.modal.open(this.modalContent, { size: 'lg' });
  }

  // addEvent(): void {
  //   this.events = [
  //     ...this.events,
  //     {
  //       title: 'New event',
  //       start: startOfDay(new Date()),
  //       end: endOfDay(new Date()),
  //       color: colors.red,
  //       draggable: true,
  //       resizable: {
  //         beforeStart: true,
  //         afterEnd: true,
  //       },
  //     },
  //   ];
  // }

  handleEventUpdate() {
    if (!this.baseCalendarEvents)
      return;

    let dateInterval: Interval = { start: startOfDay(this.viewDate), end: endOfDay(this.viewDate) };
    if (this.view === CalendarView.Week) {
      dateInterval = { start: startOfWeek(this.viewDate), end: endOfWeek(this.viewDate) };
    } else if (this.view === CalendarView.Month) {
      dateInterval = { start: startOfMonth(this.viewDate), end: endOfMonth(this.viewDate) };
    }
    let workHourEvents: BackEndCalendarEvent[] = this.baseCalendarEvents.filter(e => e.sourceType === 'WorkingHours');
    let schedulableEvents : BackEndCalendarEvent[] = this.baseCalendarEvents.filter(e => e.sourceType === 'TimeOff' || e.sourceType === 'Appointment');

    let earliestStartTime: number = min(workHourEvents.map(e => e.end)).getHours() - 1;
    let latestEndTime: number = max(workHourEvents.map(e => e.start)).getHours() + 1;

    let nonWorkDaysOfWeek: number[] = this.baseCalendarEvents.filter(e => e.sourceType === 'WorkingHoursNonWorkDay').map(e => getDay(e.start));
    let intervalDays: Date[] = eachDayOfInterval(dateInterval);
    let baseEvents: CalendarEvent[] = [];
    for (let intervalDay of intervalDays) {
      if (nonWorkDaysOfWeek.indexOf(getDay(intervalDay)) > -1) {
        baseEvents.push({
          start: startOfDay(intervalDay),
          // end :  endOfDay(intervalDay),
          title: 'Non-working day',
          allDay: true,
          color: { primary: '#bbb', secondary: '#efefef' }
        })
      }
    }
    for (let evt of schedulableEvents) {
      let x : number = 300;
      let email : string = '';
      let teamMembers : TeamMember[] = evt.teamMembers ? evt.teamMembers : [];
      if (teamMembers.length > 0) {
        let firstTeamMember : TeamMember = teamMembers[0];
        if (firstTeamMember.id)
          x = firstTeamMember.id;
        if (firstTeamMember.email) {
          email = firstTeamMember.email;
          const idx : number = email.indexOf('@')
          if (idx > -1) {
            email = email.substring(0, idx).trim();
          }
          email = ' - ' + email;
        }

      }
      const primary : string = this.colors[x % this.colors.length];
      const secondary : string = this.colors[(x + 1) % this.colors.length];
     const evtInterval  = { start: evt.start, end: evt.end }
      const text : string = this.sanitizeBackEndCalendarEventText(evt);
      if (areIntervalsOverlapping(evtInterval, dateInterval)) {
          baseEvents.push({
          id : this.makeItemId(evt),
          start: evt.start,
          end :  evt.end,
          title: text,
          allDay: evt.allDay,
          color: { primary: primary, secondary: secondary }
        });
      }
    }

    console.log('Baseevents workTime', baseEvents);

    let holidays: BackEndCalendarEvent[] = this.baseCalendarEvents
      .filter(e => (e.sourceType === 'Holiday' &&
        (isWithinInterval(e.start, dateInterval) || isWithinInterval(e.end, dateInterval)))
      )

    this.events = baseEvents.concat(holidays.map(item => ({ ...{id : this.makeItemId(item),
      start: item.start,
      end: item.end,
      title: item.text,
      allDay: item.allDay
    },  ...this.getColors(item) })));
    let nonWorkDaysExcluded: BackEndCalendarEvent[] =
    holidays.filter(e => e.sourceType != 'WorkingHoursNonWorkDay' && e.sourceType != 'Holiday');

    this.startTime = Math.min(earliestStartTime, (min(nonWorkDaysExcluded.map(e => e.end)).getHours() - 1) | 24);
    this.endTime = Math.max(latestEndTime, (max(nonWorkDaysExcluded.map(e => e.start)).getHours() + 1) | 0);
    if (isNaN(this.startTime)) {
      this.startTime = 7;
    }
    if (isNaN(this.endTime)) {
      this.endTime = 23;
    }
    console.log('Completed event update', this.view, holidays, this.events, this.startTime, this.endTime, schedulableEvents, earliestStartTime, latestEndTime);

  }

  makeItemId (item : BackEndCalendarEvent) : string {
    return item.sourceType + item.id;
  }


  getColors(item: BackEndCalendarEvent) {
    let color: EventColor = { primary: '#ad2121', secondary: '#FAE3E3' };
    if (item.sourceType === 'WorkingHours') {
      color = { primary: '#bbb', secondary: '#efefef' }
    }

    return {
      color: { ...color }
    };
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
    this.handleEventUpdate();
  }

  sanitizeBackEndCalendarEventText(evt : BackEndCalendarEvent) {
    let ret : string = evt.text;
    //console.log('sanitizeBackEndCalendarEventText', evt);
    if (evt.sourceType == 'Appointment') {
      let idx : number = evt.text.indexOf(' - ');
      if (idx > -1) {
        let familyIdentifier = evt.text.substring(0, idx);
        ret = sanitizeIdentifier(familyIdentifier, familyIdentifier) + ' - ';
        idx += 3;
        const parenIdx : number = evt.text.indexOf('(');
        if (parenIdx > -1) {
          let primary : string = sanitizeIdentifier(familyIdentifier, evt.text.substring(idx, parenIdx));
          ret = ret + primary + ' ' + evt.text.substring(parenIdx);
        }

      }
    }
    return ret;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
    this.handleEventUpdate();
  }

   colors : string[] = [
    '#DAC7FD', '#FDDAC7', '#C7FDDA',
    '#F06D82', '#82F06D',' #6D82F0',
    '#EC75C5', '#C5EC75', '#75C5EC',
    '#EFA7C2',  '#C2EFA7',  '#A7C2EF'
  ];

}

export interface CalendarBackEndPair {
  action: string;
  calendarEvent : CalendarEvent;
  backendEvent : BackEndCalendarEvent;
  checklistTemplates? : ChecklistTemplate[],
  username? : string;
}

